import qrcodeParser from "qrcode-parser";
// 引入qrcode-decoder，
// 部分网友反应上面的引入，这个引入的是一个空对象，不能使用，已经给开发者提issues了，希望能尽快修复不能使用或报错，可以试试下面这种
// import QrCode from '../node_modules/qrcode-decoder/dist/index';

export async function getQrUrl(file: any) {
  const resData = await qrcodeParser(file);
  return resData;
}
